import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CRM from "@/pages/CRM";
import Penjualan from "@/pages/Penjualan";
import SalesMobile from "@/pages/SalesMobile";
import Akuntansi from "@/pages/Akuntansi";
import Purchase from "@/pages/Purchase";
import Inventory from "@/pages/Inventory";
import Proyek from "@/pages/Proyek";
import Absensi from "@/pages/Absensi";
import Dokumen from "@/pages/Dokumen";
import Approvals from "@/pages/Approvals";
import Settings from "@/pages/Settings";
import Todo from "@/pages/Todo";
import Kalender from "@/pages/Kalender";
import Chat from "@/pages/Chat";
import Profile from "@/pages/Profile";
import Pengajuan from "@/pages/Pengajuan";
import PortalKonsumen from "@/pages/PortalKonsumen";
import ResetPassword from "@/pages/ResetPassword";
import Cuti from "@/pages/Cuti";
import MonitoringTugas from "@/pages/MonitoringTugas";
import Konsumen from "@/pages/Konsumen";
import VerifikasiDokumen from "@/pages/VerifikasiDokumen";
import AktivitasApp from "@/pages/AktivitasApp";
import Garansi from "@/pages/Garansi";
import PembayaranApp from "@/pages/PembayaranApp";
import ReferralSales from "@/pages/ReferralSales";
import PromoVoucher from "@/pages/PromoVoucher";
import TiketApp from "@/pages/TiketApp";

function Protected({ children, module }) {
  const { user, loading, hasPerm } = useAuth();
  if (loading) return <div className="min-h-screen bg-slate-950 flex items-center justify-center text-slate-500" data-testid="auth-loading">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (module && module !== "dashboard" && !hasPerm(module, "view")) {
    return <div className="text-slate-400 text-sm p-8" data-testid="access-denied">Anda tidak memiliki akses ke modul ini. Hubungi Super Admin.</div>;
  }
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-slate-950 flex items-center justify-center text-slate-500">Memuat...</div>;
  if (user && user.role === "Konsumen") {
    return (
      <Routes>
        <Route path="/portal" element={<PortalKonsumen />} />
        <Route path="/login" element={<Navigate to="/portal" replace />} />
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/reset-password" element={user ? <Navigate to="/" replace /> : <ResetPassword />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="crm" element={<Protected module="crm"><CRM /></Protected>} />
        <Route path="penjualan" element={<Protected module="penjualan"><Penjualan /></Protected>} />
        <Route path="sales" element={<Protected module="sales"><SalesMobile /></Protected>} />
        <Route path="todo" element={<Protected module="todo"><Todo /></Protected>} />
        <Route path="kalender" element={<Protected module="kalender"><Kalender /></Protected>} />
        <Route path="chat" element={<Chat />} />
        <Route path="profile" element={<Profile />} />
        <Route path="pengajuan" element={<Protected module="pengajuan"><Pengajuan /></Protected>} />
        <Route path="akuntansi" element={<Protected module="akuntansi"><Akuntansi /></Protected>} />
        <Route path="purchase" element={<Protected module="purchase"><Purchase /></Protected>} />
        <Route path="inventory" element={<Protected module="inventory"><Inventory /></Protected>} />
        <Route path="proyek" element={<Protected module="proyek"><Proyek /></Protected>} />
        <Route path="absensi" element={<Protected module="absensi"><Absensi /></Protected>} />
        <Route path="cuti" element={<Protected module="cuti"><Cuti /></Protected>} />
        <Route path="monitoring-tugas" element={<Protected module="todo"><MonitoringTugas /></Protected>} />
        <Route path="konsumen" element={<Protected module="dashboard"><Konsumen /></Protected>} />
        <Route path="verifikasi-dokumen" element={<Protected module="penjualan"><VerifikasiDokumen /></Protected>} />
        <Route path="aktivitas-app" element={<Protected module="crm"><AktivitasApp /></Protected>} />
        <Route path="garansi" element={<Protected module="penjualan"><Garansi /></Protected>} />
        <Route path="pembayaran-app" element={<Protected module="akuntansi"><PembayaranApp /></Protected>} />
        <Route path="tiket" element={<Protected module="penjualan"><TiketApp /></Protected>} />
        <Route path="referral-sales" element={<Protected module="crm"><ReferralSales /></Protected>} />
        <Route path="promo-voucher" element={<Protected module="crm"><PromoVoucher /></Protected>} />
        <Route path="dokumen" element={<Protected module="dokumen"><Dokumen /></Protected>} />
        <Route path="approvals" element={<Protected module="approval"><Approvals /></Protected>} />
        <Route path="settings" element={<Protected module="settings"><Settings /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster theme="light" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
